import { isAgreeField, isButtonField, isOptionField, isPlaceholderField, isFieldGroupRepeatable, } from './structure';
export function localizeQuestionnaire(questionnaire, language) {
    for (const sectionGroup of questionnaire) {
        localizeSectionGroup(sectionGroup, language);
    }
    return questionnaire;
}
export function localizeSectionGroup(sectionGroup, language) {
    const localizedSectionGroup = sectionGroup;
    localizedSectionGroup.title = localize(sectionGroup.title, language) ?? '';
    localizedSectionGroup.text = localize(sectionGroup.text, language);
    for (const section of sectionGroup.sections) {
        localizeSection(section, language);
    }
    return localizedSectionGroup;
}
export function localizeSection(section, language) {
    const localizedSection = section;
    localizedSection.title = localize(section.title, language) ?? '';
    localizedSection.text = localize(section.text, language);
    for (const subsection of section.subsections) {
        localizeSubsection(subsection, language);
    }
    return localizedSection;
}
export function localizeSubsection(subsection, language) {
    const localizedSubsection = subsection;
    localizedSubsection.title = localize(subsection.title, language) ?? '';
    localizedSubsection.text = localize(subsection.text, language);
    localizedSubsection.nextStepButtonText = localize(subsection.nextStepButtonText, language);
    for (const fieldGroup of subsection.fieldGroups) {
        localizeFieldGroup(fieldGroup, language);
    }
    return localizedSubsection;
}
export function localizeFieldGroup(fieldGroup, language) {
    const localizedFieldGroup = fieldGroup;
    localizedFieldGroup.title = localize(fieldGroup.title, language);
    localizedFieldGroup.text = localize(fieldGroup.text, language);
    if (isFieldGroupRepeatable(fieldGroup)) {
        const localizedRepeatedFieldGroup = localizedFieldGroup;
        localizedRepeatedFieldGroup.addQuestionButtonText = localize(fieldGroup.addQuestionButtonText, language) ?? '';
        localizedRepeatedFieldGroup.removeQuestionButtonText =
            localize(fieldGroup.removeQuestionButtonText, language) ?? '';
    }
    for (const field of fieldGroup.fields) {
        localizeField(field, language);
    }
    return localizedFieldGroup;
}
export function localizeField(field, language) {
    const localizedField = field;
    localizedField.title = localize(field.title, language);
    localizedField.text = localize(field.text, language);
    localizedField.label = localize(field.label, language);
    if (isPlaceholderField(field)) {
        localizedField.placeholder = localize(field.placeholder, language);
    }
    if (field.info) {
        const localizedInfoSupplement = localizedField.info;
        localizedInfoSupplement.text = localize(field.info.text, language) ?? '';
        localizedInfoSupplement.title = localize(field.info.title, language);
    }
    if (field.validIf?.length) {
        field.validIf.forEach((rule) => {
            const localizedRule = rule;
            localizedRule.message = localize(rule.message, language);
        });
    }
    if (isOptionField(field)) {
        const localizedOptionField = localizedField;
        localizedOptionField.options = field.options.map((option) => {
            const optionTitle = localize(option.title, language);
            const optionText = localize(option.text, language) ?? '';
            const optionInfo = option.info
                ? {
                    ...option.info,
                    title: localize(option.info.title, language),
                    text: localize(option.info.text, language) ?? '',
                }
                : undefined;
            return {
                ...option,
                text: optionText,
                title: optionTitle,
                info: optionInfo,
            };
        });
    }
    else if (isAgreeField(field)) {
        const localizedAgreeField = localizedField;
        localizedAgreeField.confirmedLabel = localize(field.confirmedLabel, language) ?? '';
        localizedAgreeField.modalHeader = localize(field.modalHeader, language) ?? '';
        localizedAgreeField.modalText = localize(field.modalText, language) ?? '';
    }
    else if (isButtonField(field)) {
        const localizedButtonField = localizedField;
        localizedButtonField.buttonText = localize(field.buttonText, language) ?? '';
    }
    return localizedField;
}
export function localize(input, language) {
    if (!input)
        return undefined;
    if (typeof input === 'string') {
        return input;
    }
    return input[language];
}
